import React, { useMemo } from "react";
import { toTitleCase } from "../../../utils/helpers";
import { getRegularTestName } from "./utils";
import RuleStatusTag from "./QCGeneral/RuleStatusTag";

const formatRegularTestsList = (tests) => {
  if (!Array.isArray(tests) || tests.length === 0) return "-";
  const labels = tests.map((spec) => getRegularTestName(spec)).filter(Boolean);
  return labels.length ? labels.join(", ") : "-";
};

const formatDisplayValue = (value) => {
  if (value == null || value === "") return "-";
  return value;
};

export const getQcRuleTestDetailItems = (ruleData) => {
  if (!ruleData) return [];

  if (ruleData.rule_type != null) {
    return [
      { key: "rule_type", label: "Type", value: formatDisplayValue(ruleData.rule_type) },
      { key: "rule_description", label: "Description", value: formatDisplayValue(ruleData.rule_description) },
      {
        key: "is_active",
        label: "Status",
        render: () => <RuleStatusTag result={ruleData.is_active} />,
      },
    ];
  }

  if (ruleData.range_spec != null) {
    return [
      { key: "customer_id", label: "Customer Id", value: formatDisplayValue(ruleData.customer_id) },
      { key: "scope", label: "Scope", value: formatDisplayValue(toTitleCase(ruleData.scope)) },
      { key: "sample_info", label: "Sample Info", value: formatDisplayValue(ruleData.sample_info) },
      {
        key: "regular_tests",
        label: "Regular Tests",
        value: formatRegularTestsList(ruleData.regular_tests),
      },
      {
        key: "range_specs",
        label: "Range Specs",
        value: formatDisplayValue(ruleData.range_spec?.raw_value),
      },
    ];
  }

  if (ruleData.sample_info && typeof ruleData.sample_info === "object") {
    return [
      { key: "customer_id", label: "Customer Id", value: formatDisplayValue(ruleData.customer_id) },
      { key: "scope", label: "Scope", value: formatDisplayValue(toTitleCase(ruleData.scope)) },
      {
        key: "sample_type",
        label: "Sample Info",
        value: formatDisplayValue(ruleData.sample_info?.sample_type),
      },
      {
        key: "regular_tests",
        label: "Regular Tests",
        value: formatRegularTestsList(ruleData.sample_info?.regular_tests),
      },
      {
        key: "qc_pointers",
        label: "QC Pointers",
        value: formatDisplayValue(ruleData.sample_info?.qc_pointers),
      },
      {
        key: "specs",
        label: "Specs",
        value: formatDisplayValue(ruleData.sample_info?.specs),
      },
    ];
  }

  return [];
};

export default function QcRuleTestDetailSection({ ruleData }) {
  const detailItems = useMemo(
    () => getQcRuleTestDetailItems(ruleData),
    [ruleData],
  );

  if (!detailItems.length) return null;

  return (
    <div className="QcRuleTestModal__RuleDetail">
      {detailItems.map(({ key, label, value, render }) => (
        <div key={key} className="QcRuleTestModal__RuleDetailItem">
          <span className="QcRuleTestModal__RuleDetailLabel">{label}</span>
          <span className="QcRuleTestModal__RuleDetailValue">
            {render ? render() : value}
          </span>
        </div>
      ))}
    </div>
  );
}
